export function formatRelativeTime(input?: string | number | Date | null): string {
  if (!input) return '';
  const d = new Date(input);
  if (isNaN(d.getTime())) return '';
  const diffMs = d.getTime() - Date.now(); // future: positive, past: negative
  const absMs = Math.abs(diffMs);

  const sec = 1000;
  const min = 60 * sec;
  const hour = 60 * min;
  const day = 24 * hour;
  const week = 7 * day;
  const month = 30 * day;
  const year = 365 * day;

  const rtf = new Intl.RelativeTimeFormat(undefined, { numeric: 'auto' });

  let value: number;
  let unit: Intl.RelativeTimeFormatUnit;
  if (absMs < 45 * sec) {
    value = Math.round(diffMs / sec);
    unit = 'second';
  } else if (absMs < 45 * min) {
    value = Math.round(diffMs / min);
    unit = 'minute';
  } else if (absMs < 22 * hour) {
    value = Math.round(diffMs / hour);
    unit = 'hour';
  } else if (absMs < 7 * day) {
    value = Math.round(diffMs / day);
    unit = 'day';
  } else if (absMs < 4 * week) {
    value = Math.round(diffMs / week);
    unit = 'week';
  } else if (absMs < 12 * month) {
    value = Math.round(diffMs / month);
    unit = 'month';
  } else {
    value = Math.round(diffMs / year);
    unit = 'year';
  }
  return rtf.format(value, unit);
}

